
<div class="redirect-container">
    <app-navbar [isDarkNavbar]="true"></app-navbar>
    <div class="router-container"></div>
  </div>